import { Activity } from 'lucide-react';

export const PulseIndicator = ({ count, insight }) => {
  return (
    <div 
      className="bg-zinc-900/50 border border-zinc-800 rounded-lg p-4 backdrop-blur-sm"
      data-testid="pulse-indicator"
    >
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-3">
          <div className="relative">
            <div className="w-3 h-3 bg-red-500 rounded-full animate-pulse-glow" />
            <div className="absolute inset-0 w-3 h-3 bg-red-500 rounded-full animate-ping opacity-75" />
          </div>
          <span className="font-heading font-semibold text-zinc-200 tracking-tight">
            LIVE PULSE
          </span>
        </div>
        <div className="flex items-center gap-2">
          <Activity className="w-4 h-4 text-amber-500" />
          <span className="font-mono text-lg text-amber-500 font-bold" data-testid="pulse-count">
            {count}
          </span>
          <span className="text-sm text-zinc-400">signals / 24h</span>
        </div>
      </div>
      {insight && (
        <div className="mt-2 pt-2 border-t border-zinc-800/50">
          <p className="text-xs text-zinc-500" data-testid="pulse-insight">
            {insight}
          </p>
        </div>
      )}
    </div>
  );
};
